import { useState, useCallback, useEffect } from 'react';

// src/universal/hooks/useCooldown/index.ts
var useCountdown = ({
  duration,
  onComplete,
  onTick,
  enabled = true,
  interval = 1e3
}) => {
  const [remaining, setRemaining] = useState(duration);
  const handleTick = useCallback(
    (prev) => {
      const next = prev - 1;
      if (next <= 0) {
        onComplete == null ? void 0 : onComplete();
        return 0;
      }
      onTick == null ? void 0 : onTick(next);
      return next;
    },
    [onComplete, onTick]
  );
  useEffect(() => {
    let timer;
    if (enabled && remaining > 0) {
      timer = setInterval(() => {
        setRemaining((prev) => {
          const next = handleTick(prev);
          if (next <= 0) {
            clearInterval(timer);
          }
          return next;
        });
      }, interval);
    }
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [enabled, interval, onComplete, onTick, remaining]);
  useEffect(() => {
    if (enabled) {
      setRemaining(duration);
    }
  }, [duration, enabled]);
  return remaining;
};

export { useCountdown };
//# sourceMappingURL=chunk-PKGQIOQW.mjs.map
//# sourceMappingURL=chunk-PKGQIOQW.mjs.map